import React, { useEffect } from 'react';
import { BsGithub } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FaReact, FaNodeJs, FaCcStripe } from 'react-icons/fa';
import { SiMongodb, SiTailwindcss, SiFirebase, SiReactrouter } from 'react-icons/si';


import img1 from '../../../images/project-details/doctors-portal/1.png';
import img2 from '../../../images/project-details/doctors-portal/2.png';
import img3 from '../../../images/project-details/doctors-portal/3.png';
import img4 from '../../../images/project-details/doctors-portal/4.png';
import img5 from '../../../images/project-details/doctors-portal/5.png';
import img6 from '../../../images/project-details/doctors-portal/6.png';
import img7 from '../../../images/project-details/doctors-portal/7.png';
import img8 from '../../../images/project-details/doctors-portal/8.png';
import img9 from '../../../images/project-details/doctors-portal/9.png';
import img10 from '../../../images/project-details/doctors-portal/10.png';
import img11 from '../../../images/project-details/doctors-portal/11.png';





import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';







import DoctorsPortalLarge from '../../../images/projects-large-image/DoctorsPortal.png';

import useTitle from '../../../Hooks/useTitle';









const DoctorsPortalDetails = () => {

    useTitle('Project | Doctors Portal')

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])





    //Best Bike details er 1st pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const divStyle = {
        backgroundImage: ` url(${DoctorsPortalLarge})`,
        transition: 'ease 7s'
    };
    const handleHover = () => {
        divStyle.transition = 'ease 7s'
    };
    const handleUnHover = () => {
        divStyle.transition = 'ease 1s'
    };













    return (
        <div className='lg:px-8 md:px-5 px-3'>

            <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse lg:mb-24 md:mb-16 sm:mb-16 mb-16 mt-16'>
                <h1 className='uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-4xl  animation ' data-aos='flip-right'>Doctors <span className='text-rose-600 text-5xl'>Portal</span></h1>
            </div>




            <div className=' grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-10  gap-y-8 mb-24 animation' data-aos='zoom-in'>


                <div className='lg:w-[410px] md:w-[335px] sm:w-[355px] w-[355px] lg:mx-0 md:mx-4 sm:mx-auto mx-auto' >
                    <div
                        style={divStyle}
                        onMouseEnter={handleHover}
                        onMouseLeave={handleUnHover}
                        className=" bg-top bg-cover  hover:bg-bottom rounded-lg  lg:w-[460px] lg:h-[308px] md:w-[330px] md:h-[220px] sm:w-[350px] sm:h-[220px] w-[350px] h-[220px] mx-auto"></div>
                </div>



                <div className="card   transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300     mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] ">
                    <img className='rounded-lg ' src={img2} alt="bike!" />
                </div>

                <div className="card mx-auto  transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img1} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img3} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img4} alt="bike!" />
                </div>

                <div className="card  mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img5} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img6} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img7} alt="bike!" />
                </div>


                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img8} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img9} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img10} alt="bike!" />
                </div>

                <div className="card mx-auto transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px]">
                    <img className='rounded-lg ' src={img11} alt="bike!" />
                </div>

            </div>

            <div>
                <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                </h1>

                <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                    <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">

                        <h1 className='text-justify text-lg' > ⚪ Doctors Portal is an online dental treatment service booking platform that offers different dental treatments. Such as: Teeth Orthodontics, Cosmetic Dentistry, Teeth Cleaning, Cavity Protection, Pediatric Dental, Oral Surgery, etc. </h1> <br></br>

                        <h1 className='text-justify text-lg' > ⚪  After completing a successful registration a user can book appointment for an oral treatment based on his desired date and time. On the treatment day after finishing the treatment user can pay the price. If he wants he can pay the service price before. </h1> <br></br>

                        <h1 className='text-justify text-lg '> ⚪ This website is made by using React Router DOM, Firebase Authentication, amd Mongodb as the database. CRUD operation is done where needed. Besides tailwind css is used for the styling purpose. Some component libraries are also used for the design. </h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪  React hot toast and sweet alert is added to show the alerts for better user experience. For the payment gateway Stripe is used</h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ All the data are sent to the mongodb server. there is no static data in this project. This project is based on online used bike selling and For that I have added all the data to the Mongodb database and fetch the data when needed.</h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ As, there are 2 major users in this project so, I have made a dashboard and differentiate the users based on their role. Admin has the highest authority and he can manage the system. Admin has the highest authority. If Admin wants he can add and delete doctors. Admin can make a simple use to "Admin" by verifying his status to admin. A user can see his appointments in his dashboard.</h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ Authentication is an important part of the website. There are some routes that are private routes. Which means a user can not visit the route if he is not logged in. For the Authentication purpose I have used the google's Firebase authentication system. I have added some authentication systems. Email-Password Login and Google Login </h1>

                    </div>


                    <div className='w-full sm:w-full md:w-full lg:w-2/4'>

                        <h2 className='text-center text-3xl mt-4 mb-12 '>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div >

                            <a href='https://doctors-portal-e235e.web.app/' target='blank' title='Live Site Demo'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-70 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Live Website</span>
                                            <FaEye className='text-3xl text-white'></FaEye>
                                        </div>
                                    </button>
                                </div>
                            </a>



                            <a href='https://github.com/Fahimsakib1/doctors-portal-client-side' target='blank' title='Client Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-right'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-blue-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Client Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>


                            <a href='https://github.com/Fahimsakib1/doctors-portal-server' target='blank' title='Server Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-green-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Server Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>



                        </div>



                        <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaReact className='text-4xl mx-2 text-cyan-500'></FaReact>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaNodeJs className='text-4xl mx-2 text-green-500'></FaNodeJs>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Node JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiFirebase className='text-4xl mx-2 text-yellow-400'></SiFirebase>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Firebase</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiReactrouter className='text-4xl mx-2 text-red-600'></SiReactrouter>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React Router</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiTailwindcss className='text-4xl mx-2 text-sky-500'></SiTailwindcss>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Tailwind</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiMongodb className='text-4xl mx-2 text-green-500'></SiMongodb>
                                <h1 className='text-white text-2xl py-2  mr-4'>MongoDB</h1>
                            </div>

                            <div className='border-2 border-violet-700  mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaCcStripe className='text-4xl mx-2 text-blue-600'></FaCcStripe>
                                <h1 className='text-white text-2xl py-2  mr-4'>Stripe</h1>
                            </div>

                        </div>




                    </div>

                </div>




                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}



                <div className='mx-auto text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>




            </div>
        </div>
    );
};

export default DoctorsPortalDetails;